import React from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';

import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';


import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from '@material-ui/core/Switch';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Divider from '@material-ui/core/Divider';
import Select from "../../../../common/components/input/suggest-select";
import {connect} from "react-redux";
import {getValueHash, isObjectEquals} from "../../../../common/utils/array";
import {isHankaku} from "../../../../common/utils/validation";


const styles = theme => ({
	root: {
		width: '100%',
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
	formGroups: {
		paddingTop: 5,
		alignItems: 'start'
	},
	halfTextArea: {
		flexBasis: 2,
		flexGrow: 2
	},
	quadTextArea: {
		flexBasis: 1,
		flexGrow: 1
	},
	halfDivider: {
		width: 30
	},
	checkBoxWrapper: {
		paddingTop: 10
	},
	divider: {
		marginTop: 15,
		marginBottom: 15
	},
	ExpansionPanelDetailsRowTitle: {
		color: 'rgba(0,0,0,0.54)',
		paddingRight: 20,
		paddingTop: 12
	},
	ExpansionPanelDetailsRowTitleSecond: {
		borderLeft: 'rgba(0,0,0,0.3) solid 1px',
		paddingLeft: 20,
		paddingTop: 12

	},
	electronicGroups: {
		border: 'solid 1px rgba(0,0,0,0.12)',
		borderRadius: 5,
		padding: '25px 20px 20px 20px',
		marginTop: -25,


	},
	electronicGroupsHidden: {
		backgroundColor: '#FFFFFF'
	},
	entryGroups: {
		border: 'solid 1px rgba(0,0,0,0.12)',
		borderRadius: 5,
		padding: '25px 20px 20px 20px',
		marginTop: -25,
	},
	selectHelperText: {
		color: "#F44336",
		fontSize: '0.75rem',
		marginTop: 8,
		minHeight: '1em',
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		lineHeight: '1em'
	},
	errorText: {
		color: "#F44336"
	},
	padding: {
		padding: `0 ${theme.spacing.unit * 2}px`,
	},
	optionContainer: {
		paddingBottom: 120
	},
	tabContainer: {
		padding: 20
	}
});

const flg = [
	1 << 0
	, 1 << 1
	, 1 << 2
	, 1 << 3
	, 1 << 4
	, 1 << 5
	, 1 << 6
	, 1 << 7
	, 1 << 8
	, 1 << 9
	, 1 << 10
	, 1 << 11
	, 1 << 12
];

const requireField = [
	"KanriKeiyakuKigyouCD",
	"JigyoushaName1",
	"DenpyoYoshikiCD",
];

const tab1_contents = [
	"KanriKeiyakuKigyouCD",
	"JigyoushaName1",
	"JigyoushaName",
	"JigyoushaName2",
	"Furigana",
	"Ryakushou",
	"TantoushaName",
	"Keishou",
	"ZipCD",
	"Address1",
	"Address2",
	"Tel1",
	"Tel2",
	"Tel3",
	"Fax",
	"MailAddress",
	"URL",
	"JigyoushaShubetsu",
	"KanriJigyoushaCD",
	"Biko1",
	"Biko2",
	"Biko3",
	"Biko4",
]

const tab2_contents = [
	"DenpyoYoshikiCD",
	"Koyuran1",
	"Koyuran2",
	"Koyuran3",
	"Koyuran4",
]

const tab3_contents = [
	"RiyouOptionKbn",
	"ElectronicReceiptFlg",
	"MakerElectronicReceiptFlg",
	"ERReceiverServiceDivide",
	"ERMakerServiceDivide",
	"MakerPaperLogicTokens",
	"ERMakerSendSlipsDivide",
	"ReceiverPaperLogicTokens",
	"SecomReceiverAreaCD",
	"DataTeikyoumotoCD",
	"ButsuryuBotenCD",
	"MakerCD",
	"ASNRenkeiCD"
]


const ERServiceDivides = [
	{
		value: "0",
		label: "利用しない"
	},
	{
		value: "1",
		label: "PaperLogic"
	},
	{
		value: "2",
		label: "セコム"
	},


]

const ERMakerSendSlipsDivide = [
	{
		value: "0",
		label: "納品書（控）+ 受領書"
	},
	{
		value: "1",
		label: "受領書"
	},
]


const tabContainerBase = ({addClassName, ...props}) => {
	const {classes, children} = props;
	return (
		<Paper square className={classNames(classes.tabContainer, addClassName)}>
			{children}
		</Paper>
	);
}
export const TabContainer = withStyles(styles)(tabContainerBase);


class innerForm extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			selectedTab: 0,
			dataSource: getValueHash(props.dataSource),
			errors: {}
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (!isObjectEquals(this.state.dataSource, nextProps.dataSource)) {
			this.setState({
				dataSource: getValueHash(nextProps.dataSource)
			});
		}
		if (this.props.isAddConditions === false && nextProps.isAddConditions === true) {
			const errors = this.errorChecks(nextProps.dataSource);
			this.setState({
				dataSource: getValueHash(nextProps.dataSource),
				errors
			});
			if (nextProps.afterChangeFunc) nextProps.afterChangeFunc(getValueHash(nextProps.dataSource), errors);
		}
		if (nextProps.isClear) {
			this.setState({
				errors: {},
				selectedTab: 0,
			});
		}
	}

	handleChangeTabs = (event, selectedTab) => {
		this.setState({selectedTab});
	}


	setValues = (key, data) => {
		if (Object.prototype.toString.call(data) !== '[object Object]') return "";
		if (!(key in data)) return "";
		if (data[key] === null) return "";

		return String(data[key]);
	}

	handleChangeText = (event) => {
		let {dataSource} = this.state;
		dataSource[event.target.name] = event.target.value;
		const errors = this.errorChecks(dataSource, event.target.name);
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}


	handleChangeCheck = (event, value) => {
		let {dataSource} = this.state;
		switch (event.target.name) {
			case "KeiyakuKigyouCD":
				if (value) {
					dataSource[event.target.name] = event.target.value;
				} else {
					dataSource[event.target.name] = null;
				}
				break;
			case "JigyoushaShubetsu":
			case "RiyouOptionKbn":
				dataSource[event.target.name] ^= flg[parseInt(event.target.value, 10)];
				break;
			case "NiukeshoOption":
				dataSource["RiyouOptionKbn"] ^= flg[parseInt(event.target.value, 10)];
				if (!value && (this.setValues("RiyouOptionKbn", dataSource) & flg[0]) !== 0) {
					dataSource["RiyouOptionKbn"] ^= 1;
				}
				dataSource[event.target.name] ^= flg[parseInt(event.target.value, 10)];
				break;
			case "IfmtOption":
				dataSource["RiyouOptionKbn"] ^= flg[parseInt(event.target.value, 10)];
				if (!value && (this.setValues("RiyouOptionKbn", dataSource) & flg[7]) !== 0) {
					dataSource["RiyouOptionKbn"] ^= 128;
				}
				dataSource[event.target.name] ^= flg[parseInt(event.target.value, 10)];
				break;
			case "ElectronicReceiptFlg":
				if (value) {
					dataSource[event.target.name] = "1";
				} else {
					dataSource[event.target.name] = "0";
					dataSource["ERReceiverServiceDivide"] = "0";
					dataSource["ReceiverPaperLogicTokens"] = "";
					dataSource["SecomReceiverAreaCD"] = ""
					dataSource["RiyouOptionKbn"] ^= flg[parseInt(event.target.value, 10)];
					if (!value && (this.setValues("RiyouOptionKbn", dataSource) & flg[8]) !== 0) {
						dataSource["RiyouOptionKbn"] ^= 256;
					}
					if (!value && (this.setValues("RiyouOptionKbn", dataSource) & flg[11]) !== 0) {
						dataSource["RiyouOptionKbn"] ^= 2048;
					}
					if (!value && (this.setValues("RiyouOptionKbn", dataSource) & flg[12]) !== 0) {
						dataSource["RiyouOptionKbn"] ^= 4096;
					}
					dataSource[event.target.name] ^= flg[parseInt(event.target.value, 10)];
				}
				break;
			case "MakerElectronicReceiptFlg":
				if (value) {
					dataSource[event.target.name] = "1";
				} else {
					dataSource[event.target.name] = "0";
					dataSource["ERMakerServiceDivide"] = "0";
					dataSource["MakerPaperLogicTokens"] = "";
					dataSource["PdfSection"] = "";
				}
				break;
			case "OptionKbnEntry":
				if (value) {
					dataSource["RiyouOptionKbn"] ^= flg[parseInt(event.target.value, 10)];
				} else {
					dataSource["RiyouOptionKbn"] ^= flg[parseInt(event.target.value, 10)];
					dataSource["DataTeikyoumotoCD"] = "";
					dataSource["ButsuryuBotenCD"] = "";
					dataSource["MakerCD"] = "";
				}
				break;
			case "OptionKbnASN":
				if (value) {
					dataSource["RiyouOptionKbn"] ^= flg[parseInt(event.target.value, 10)];
				} else {
					dataSource["RiyouOptionKbn"] ^= flg[parseInt(event.target.value, 10)];
					dataSource["ASNRenkeiCD"] = "";
				}
				break;
			default:
				if (value) {
					dataSource[event.target.name] = "1";
				} else {
					dataSource[event.target.name] = "0";
				}


		}
		const errors = this.errorChecks(dataSource, event.target.name);
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeKeiyakuKigyou = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.KanriKeiyakuKigyouCD = value.value;
			if (dataSource.KeiyakuKigyouCD !== value.value) {
				dataSource.KeiyakuKigyouCD = null;
			}
		} else {
			dataSource.KanriKeiyakuKigyouCD = null;
			dataSource.KeiyakuKigyouCD = null;
		}

		const errors = this.errorChecks(dataSource, "KanriKeiyakuKigyouCD");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeDataTeikyoumotoCD = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.DataTeikyoumotoCD = value.value;
			if (dataSource.DataTeikyoumotoCD !== value.value) {
				dataSource.DataTeikyoumotoCD = null;
			}
		} else {
			dataSource.DataTeikyoumotoCD = null;
			dataSource.DataTeikyoumotoCD = null;
		}

		const errors = this.errorChecks(dataSource, "DataTeikyoumotoCD");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeASNRenkeiCD = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.ASNRenkeiCD = value.value;
			if (dataSource.ASNRenkeiCD !== value.value) {
				dataSource.ASNRenkeiCD = null;
			}
		} else {
			dataSource.ASNRenkeiCD = null;
			dataSource.ASNRenkeiCD = null;
		}

		const errors = this.errorChecks(dataSource, "ASNRenkeiCD");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeButsuryuBotenCD = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.ButsuryuBotenCD = value.value;
			if (dataSource.ButsuryuBotenCD !== value.value) {
				dataSource.ButsuryuBotenCD = null;
			}
		} else {
			dataSource.ButsuryuBotenCD = null;
			dataSource.ButsuryuBotenCD = null;
		}

		const errors = this.errorChecks(dataSource, "ButsuryuBotenCD");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}
	handleChangeMakerCD = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.MakerCD = value.value;
			if (dataSource.MakerCD !== value.value) {
				dataSource.MakerCD = null;
			}
		} else {
			dataSource.MakerCD = null;
			dataSource.MakerCD = null;
		}

		const errors = this.errorChecks(dataSource, "MakerCD");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeDenpyoYoshiki = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.DenpyoYoshikiCD = value.value;
		} else {
			dataSource.DenpyoYoshikiCD = null;
		}
		const errors = this.errorChecks(dataSource, "DenpyoYoshikiCD");
		this.setState({
			dataSource,
			errors
		});

		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeERReceiverServiceDivide = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.ERReceiverServiceDivide = value.value;
		} else {
			dataSource.ERReceiverServiceDivide = "0";
		}

		dataSource["ReceiverPaperLogicTokens"] = "";
		dataSource["SecomReceiverAreaCD"] = ""

		const errors = this.errorChecks(dataSource, "ERReceiverServiceDivide");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeERMakerServiceDivide = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.ERMakerServiceDivide = value.value;
		} else {
			dataSource.ERMakerServiceDivide = "0";
		}
		dataSource["MakerPaperLogicTokens"] = "";
		dataSource["ERMakerSendSlipsDivide"] = "0";
		dataSource["PdfSection"] = "";

		const errors = this.errorChecks(dataSource, "ERMakerServiceDivide");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeERMakerSendSlipsDivide = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.ERMakerSendSlipsDivide = value.value;
		} else {
			dataSource.ERMakerSendSlipsDivide = "0";
		}

		const errors = this.errorChecks(dataSource, "ERMakerSendSlipsDivide");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}
	handleChangeKanriJigyousha = (value) => {
		let {dataSource} = this.state;
		if (value) {
			dataSource.KanriJigyoushaCD = value.value;
		} else {
			dataSource.KanriJigyoushaCD = null;
		}
		const errors = this.errorChecks(dataSource, "KanriJigyoushaCD");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	handleChangeEntryflg = (event, value) => {
		let {dataSource} = this.state;
		dataSource[event.target.name] ^= flg[parseInt(event.target.value, 10)];
		const errors = this.errorChecks(dataSource, "DataTeikyoumotoCD");
		this.setState({
			dataSource,
			errors
		});
		if (this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource, errors);
	}

	isError = (key, errors) => {
		return Boolean(key in errors && errors[key]);
	}
	getErrorText = (key, errors) => {
		if (!(key in errors)) return "";
		if (errors[key] === null || errors[key] === "null" || errors[key] === undefined) return "";
		return errors[key];
	}

	errorChecks = (data, key) => {
		let checkColumn = [];
		if (key === undefined) {
			Object.keys(data).forEach((column) => {
				checkColumn.push(column);
			});
		} else {
			checkColumn.push(key);
		}
		let errors = getValueHash(this.state.errors);
		checkColumn.forEach((column) => {
			if (column in errors) delete errors[column];
			switch (column) {
				case "JigyoushaShubetsu":
					if (this.setValues(column, data) === "0") {
						errors[column] = "1つ以上選択"
					}
					break;
				case "ElectronicReceiptFlg":
				case "ERReceiverServiceDivide":
				case "ReceiverPaperLogicTokens":
				case "SecomReceiverAreaCD":
					delete errors["ERReceiverServiceDivide"];
					delete errors["ReceiverPaperLogicTokens"];
					delete errors["SecomReceiverAreaCD"];

					if (this.setValues("ERReceiverServiceDivide", data) === "1") {
						if (this.setValues("ReceiverPaperLogicTokens", data) === "") {
							errors["ReceiverPaperLogicTokens"] = "必須入力"
							break;
						}
						if (!isHankaku(this.setValues("ReceiverPaperLogicTokens", data))) {
							errors["ReceiverPaperLogicTokens"] = "半角英数記号で入力"
							break;
						}
					}

					if (this.setValues("ERReceiverServiceDivide", data) === "2") {
						if (!isHankaku(this.setValues("SecomReceiverAreaCD", data))) {
							errors["SecomReceiverAreaCD"] = "半角英数記号で入力"
							break;
						}
					}
					break;
				case "MakerElectronicReceiptFlg":
				case "ERMakerServiceDivide":
				case "MakerPaperLogicTokens":

					delete errors["ERMakerServiceDivide"];
					delete errors["MakerPaperLogicTokens"];

					if (this.setValues("ERMakerServiceDivide", data) === "1") {
						if (this.setValues("MakerPaperLogicTokens", data) === "") {
							errors["MakerPaperLogicTokens"] = "必須入力"
							break;
						}
						if (!isHankaku(this.setValues("MakerPaperLogicTokens", data))) {
							errors["MakerPaperLogicTokens"] = "半角英数記号で入力"
							break;
						}
					}
					break;
				case "JigyoushaKanriKbn":
				case "KanriJigyoushaCD":
					if (this.setValues("JigyoushaKanriKbn", data) === "0" &&
						this.setValues("KanriJigyoushaCD", data) === "") {
						errors["KanriJigyoushaCD"] = "必須入力"
					}
					break;
				default:
					//requireCheck
					if (requireField.indexOf(column) >= 0 && this.setValues(column, data) === "") {
						errors[column] = "必須入力"
					}
			}
		});

		return errors;
	}


	render() {
		const {classes, settings, allDisabled} = this.props;
		const {selectedTab, dataSource, errors} = this.state;

		const isKeiyakuKigouAdmin = this.setValues("KeiyakuKigyouCD", dataSource) !== "" && this.setValues("KeiyakuKigyouCD", dataSource) === this.setValues("KanriKeiyakuKigyouCD", dataSource);

		const JigyoushaShubetsuMaker = (this.setValues("JigyoushaShubetsu", dataSource) & flg[0]) === flg[0];
		const JigyoushaShubetsuNohinJigyousha = (this.setValues("JigyoushaShubetsu", dataSource) & flg[1]) === flg[1];
		const JigyoushaShubetsu3PL = (this.setValues("JigyoushaShubetsu", dataSource) & flg[3]) === flg[3];
		const JigyoushaShubetsuElectronicReceipt = (this.setValues("JigyoushaShubetsu", dataSource) & flg[2]) === flg[2];
		const JigyoushaShubetsuChoai = (this.setValues("JigyoushaShubetsu", dataSource) & flg[4]) === flg[4];


		const OptionKbnNiukePdf = (this.setValues("RiyouOptionKbn", dataSource) & flg[0]) === flg[0];
		const OptionKbnStatic = (this.setValues("RiyouOptionKbn", dataSource) & flg[1]) === flg[1];
		const OptionKbnMain = (this.setValues("RiyouOptionKbn", dataSource) & flg[2]) === flg[2];
		const OptionKbnArrival = (this.setValues("RiyouOptionKbn", dataSource) & flg[3]) === flg[3];
		const OptionKbnNiuke = (this.setValues("RiyouOptionKbn", dataSource) & flg[4]) === flg[4];
		const OptionKbnIfmt = (this.setValues("RiyouOptionKbn", dataSource) & flg[5]) === flg[5];
		const OptionKbnEntry = (this.setValues("RiyouOptionKbn", dataSource) & flg[6]) === flg[6];
		const OptionKbnIfmtEpal = (this.setValues("RiyouOptionKbn", dataSource) & flg[7]) === flg[7];
		const OptionKbnElectronicEpal = (this.setValues("RiyouOptionKbn", dataSource) & flg[8]) === flg[8];
		const OptionKbnASN = (this.setValues("RiyouOptionKbn", dataSource) & flg[9]) === flg[9];
		const OptionKbnDeliveryStatus = (this.setValues("RiyouOptionKbn", dataSource) & flg[10]) === flg[10];
		const OptionKbnDeliveryMobileReceipt = (this.setValues("RiyouOptionKbn", dataSource) & flg[11]) === flg[11];
		const OptionKbnReceiptArrivalPdf = (this.setValues("RiyouOptionKbn", dataSource) & flg[12]) === flg[12];

		const NiukePdfDisabled = allDisabled || !OptionKbnNiuke;
		const IfmtEpalDisabled = allDisabled || !OptionKbnIfmt;

		const ElectronicReceiptFlg = (this.setValues("ElectronicReceiptFlg", dataSource) === "1");
		const ERReceiverServiceDivideDisabled = allDisabled || !ElectronicReceiptFlg;
		const MakerElectronicReceiptFlg = (this.setValues("MakerElectronicReceiptFlg", dataSource) === "1");
		const ERMakerServiceDivideDisabled = allDisabled || !MakerElectronicReceiptFlg;
		const ERMakerSendSlipsDivideDisabled = allDisabled || !MakerElectronicReceiptFlg;
		const EntryFlgDivideDisabled = allDisabled || !OptionKbnEntry;
		const ASNRenkeiDivideDisabled = allDisabled || !OptionKbnASN;


		let tab1_error_count = 0;
		let tab2_error_count = 0;
		let tab3_error_count = 0;
		Object.keys(errors).forEach((column) => {
			if (tab1_contents.indexOf(column) !== -1) tab1_error_count++;
			if (tab2_contents.indexOf(column) !== -1) tab2_error_count++;
			if (tab3_contents.indexOf(column) !== -1) tab3_error_count++;
		});


		const butsuryuBotenList = settings.jigyoushaList.map(suggestion => (
			{
				value: suggestion.JigyoushaCD,
				label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
				name: suggestion.JigyoushaName,
			}
		));
		const makerList = settings.jigyoushaList.flatMap(suggestion =>
			(suggestion.JigyoushaIsMaker === "1") ?
				{
					value: suggestion.JigyoushaCD,
					label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
					name: suggestion.JigyoushaName,
				}
				: [])

		return (
			<div className={classes.root}>
				<AppBar position="static">
					<Tabs
						value={selectedTab}
						onChange={this.handleChangeTabs}
					>
						<Tab label={
							tab1_error_count === 0 ? "基本設定" :
								<Badge className={classes.padding} color="error" badgeContent={tab1_error_count}>
									基本設定
								</Badge>
						}/>
						<Tab label={
							tab2_error_count === 0 ? "帳票設定" :
								<Badge className={classes.padding} color="error" badgeContent={tab2_error_count}>
									帳票設定
								</Badge>
						}/>
						<Tab label={
							tab3_error_count === 0 ? "オプション設定" :
								<Badge className={classes.padding} color="error" badgeContent={tab3_error_count}>
									オプション設定
								</Badge>
						}/>
					</Tabs>
				</AppBar>
				{selectedTab === 0 &&
				<TabContainer>
					<FormGroup row className={classes.formGroups}>
						<div className={classes.halfTextArea}>
							<Select
								inputLabel={"企業CD"}
								defaultKeyValue={this.setValues("KanriKeiyakuKigyouCD", dataSource)}
								suggestions={settings.keiyakukigyouData}
								afterChangeFunction={this.handleChangeKeiyakuKigyou}
								createTextPrefix={"企業CD"}
								disabled={allDisabled}
								error={this.isError("KanriKeiyakuKigyouCD", errors)}
							/>
							{this.isError("KanriKeiyakuKigyouCD", errors) &&
							<p className={classes.selectHelperText}>
								{errors.KanriKeiyakuKigyouCD}
							</p>
							}
						</div>
						<div className={classes.halfDivider}/>
						<div className={classes.halfTextArea} style={{paddingTop: 8}}>
							<FormControlLabel
								control={
									<Switch
										checked={isKeiyakuKigouAdmin}
										onChange={this.handleChangeCheck}
										color="primary"
										disabled={allDisabled}
										name="KeiyakuKigyouCD"
										value={this.setValues("KanriKeiyakuKigyouCD", dataSource)}
									/>
								}
								label="この企業の管理事業者とする"
							/>
						</div>
					</FormGroup>
					<Divider className={classes.divider}/>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="事業者名1"
							placeholder="事業者名1"
							value={this.setValues("JigyoushaName1", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="JigyoushaName1"
							error={this.isError("JigyoushaName1", errors)}
							helperText={this.getErrorText("JigyoushaName1", errors)}
							inputProps={{
								maxLength: 40
							}}
						/>
						<div className={classes.halfDivider}/>
						<TextField
							label="事業者名2"
							placeholder="事業者名2"
							value={this.setValues("JigyoushaName2", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="JigyoushaName2"
							error={this.isError("JigyoushaName2", errors)}
							helperText={this.getErrorText("JigyoushaName2", errors)}
							inputProps={{
								maxLength: 40
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="フリガナ"
							placeholder="フリガナ"
							value={this.setValues("Furigana", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Furigana"
							error={this.isError("Furigana", errors)}
							helperText={this.getErrorText("Furigana", errors)}
							inputProps={{
								maxLength: 40
							}}
						/>
						<div className={classes.halfDivider}/>
						<TextField
							label="略称"
							placeholder="略称"
							value={this.setValues("Ryakushou", dataSource)}
							className={classes.quadTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Ryakushou"
							error={this.isError("Ryakushou", errors)}
							helperText={this.getErrorText("Ryakushou", errors)}
							inputProps={{
								maxLength: 40
							}}
						/>
						<div className={classes.halfDivider}/>
						<div className={classes.quadTextArea}>

						</div>
					</FormGroup>
					<Divider className={classes.divider}/>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="管理者名"
							placeholder="管理者名"
							value={this.setValues("TantoushaName", dataSource)}
							className={classes.quadTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="TantoushaName"
							error={this.isError("TantoushaName", errors)}
							helperText={this.getErrorText("TantoushaName", errors)}
							inputProps={{
								maxLength: 40
							}}
						/>
						<div className={classes.halfDivider}/>
						<div className={classes.halfTextArea}/>
						<div className={classes.halfDivider}/>
						<div className={classes.halfTextArea}/>
					</FormGroup>
					<Divider className={classes.divider}/>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="住所1"
							placeholder="住所1"
							value={this.setValues("Address1", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Address1"
							error={this.isError("Address1", errors)}
							helperText={this.getErrorText("Address1", errors)}
							inputProps={{
								maxLength: 40
							}}
						/>
						<div className={classes.halfDivider}/>
						<TextField
							label="住所2"
							placeholder="住所2"
							value={this.setValues("Address2", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Address2"
							error={this.isError("Address2", errors)}
							helperText={this.getErrorText("Address2", errors)}
							inputProps={{
								maxLength: 40
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="電話番号"
							placeholder="電話番号"
							value={this.setValues("Tel1", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Tel1"
							error={this.isError("Tel1", errors)}
							helperText={this.getErrorText("Tel1", errors)}
							inputProps={{
								maxLength: 40
							}}
						/>
						<div className={classes.halfDivider}/>
						<TextField
							label="メールアドレス"
							placeholder="メールアドレス"
							value={this.setValues("MailAddress", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="MailAddress"
							error={this.isError("MailAddress", errors)}
							helperText={this.getErrorText("MailAddress", errors)}
							inputProps={{
								maxLength: 50
							}}
						/>
					</FormGroup>
					<Divider className={classes.divider}/>
					<FormGroup row className={classes.formGroups}>
						<div
							className={classNames(classes.ExpansionPanelDetailsRowTitle, this.isError("JigyoushaShubetsu", errors) ? classes.errorText : "")}>
							事業者種別
						</div>
						<FormControlLabel
							control={
								<Checkbox
									checked={JigyoushaShubetsuMaker}
									onChange={this.handleChangeCheck}
									color="primary"
									disabled={allDisabled}
									value={"0"}
									name={"JigyoushaShubetsu"}
								/>
							}
							label="メーカー"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={JigyoushaShubetsuNohinJigyousha}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"1"}
									name={"JigyoushaShubetsu"}
								/>
							}
							label="納品事業者"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={JigyoushaShubetsu3PL}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"3"}
									name={"JigyoushaShubetsu"}
								/>
							}
							label="3PL"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={JigyoushaShubetsuElectronicReceipt}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"2"}
									name={"JigyoushaShubetsu"}
								/>
							}
							label="電子受領ユーザー"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={JigyoushaShubetsuChoai}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"4"}
									name={"JigyoushaShubetsu"}
								/>
							}
							label="帳合先"
						/>
					</FormGroup>
					{this.isError("JigyoushaShubetsu", errors) &&
					<p className={classes.selectHelperText}>
						{errors.JigyoushaShubetsu}
					</p>
					}
					<Divider className={classes.divider}/>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="備考1"
							placeholder="備考1"
							value={this.setValues("Biko1", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Biko1"
							error={this.isError("Biko1", errors)}
							helperText={this.getErrorText("Biko1", errors)}
							inputProps={{
								maxLength: 60
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="備考2"
							placeholder="備考2"
							value={this.setValues("Biko2", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Biko2"
							error={this.isError("Biko2", errors)}
							helperText={this.getErrorText("Biko2", errors)}
							inputProps={{
								maxLength: 60
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="備考3"
							placeholder="備考3"
							value={this.setValues("Biko3", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Biko3"
							error={this.isError("Biko3", errors)}
							helperText={this.getErrorText("Biko3", errors)}
							inputProps={{
								maxLength: 60
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="備考4"
							placeholder="備考4"
							value={this.setValues("Biko4", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Biko4"
							error={this.isError("Biko4", errors)}
							helperText={this.getErrorText("Biko4", errors)}
							inputProps={{
								maxLength: 60
							}}
						/>
					</FormGroup>
				</TabContainer>
				}
				{selectedTab === 1 &&
				<TabContainer>
					<FormGroup row className={classes.formGroups}>
						<div className={classes.halfTextArea}>
							<Select
								inputLabel={"伝票様式"}
								defaultKeyValue={this.setValues("DenpyoYoshikiCD", dataSource)}
								suggestions={settings.denpyoYoshikiData}
								afterChangeFunction={this.handleChangeDenpyoYoshiki}
								createTextPrefix={"伝票様式"}
								disabled={allDisabled}
								error={this.isError("DenpyoYoshikiCD", errors)}
								isClearable={false}
							/>
							{this.isError("DenpyoYoshikiCD", errors) &&
							<p className={classes.selectHelperText}>
								{errors.DenpyoYoshikiCD}
							</p>
							}
						</div>
					</FormGroup>
					<Divider className={classes.divider}/>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="固有欄1"
							placeholder="固有欄1"
							value={this.setValues("Koyuran1", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Koyuran1"
							error={this.isError("Koyuran1", errors)}
							helperText={this.getErrorText("Koyuran1", errors)}
							inputProps={{
								maxLength: 12
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="固有欄2"
							placeholder="固有欄2"
							value={this.setValues("Koyuran2", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Koyuran2"
							error={this.isError("Koyuran2", errors)}
							helperText={this.getErrorText("Koyuran2", errors)}
							inputProps={{
								maxLength: 12
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="固有欄3"
							placeholder="固有欄3"
							value={this.setValues("Koyuran3", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Koyuran3"
							error={this.isError("Koyuran3", errors)}
							helperText={this.getErrorText("Koyuran3", errors)}
							inputProps={{
								maxLength: 12
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="固有欄4"
							placeholder="固有欄4"
							value={this.setValues("Koyuran4", dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Koyuran4"
							error={this.isError("Koyuran4", errors)}
							helperText={this.getErrorText("Koyuran4", errors)}
							inputProps={{
								maxLength: 12
							}}
						/>
					</FormGroup>

				</TabContainer>
				}
				{selectedTab === 2 &&
				<TabContainer addClassName={classes.optionContainer}>
					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							control={
								<Switch
									checked={OptionKbnMain}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"2"}
									name={"RiyouOptionKbn"}
								/>
							}
							label="伝票印刷機能を利用する"
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							className={classes.electronicGroupsHidden}
							control={
								<Switch
									checked={OptionKbnArrival}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"3"}
									name={"RiyouOptionKbn"}
								/>
							}
							label="着荷機能を利用する"
						/>
					</FormGroup>


					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							className={classes.electronicGroupsHidden}
							control={
								<Switch
									checked={OptionKbnNiuke}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"4"}
									name={"NiukeshoOption"}
								/>
							}
							label="荷受書機能を利用する"
						/>
					</FormGroup>
					<div className={classes.entryGroups}>
						<FormGroup row className={classes.formGroups}>
							<FormControlLabel
								control={
									<Switch
										checked={OptionKbnNiukePdf}
										onChange={this.handleChangeCheck}
										disabled={NiukePdfDisabled}
										color="primary"
										value={"0"}
										name={"RiyouOptionKbn"}
									/>
								}
								label="PDFアップロードを利用する"
							/>
						</FormGroup>
					</div>

					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							className={classes.electronicGroupsHidden}
							control={
								<Switch
									checked={OptionKbnIfmt}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"5"}
									name={"IfmtOption"}
								/>
							}
							label="配送モバイルを利用する"
						/>
					</FormGroup>
					<div className={classes.entryGroups}>
						<FormGroup row className={classes.formGroups}>
							<FormControlLabel
								control={
									<Switch
										checked={OptionKbnIfmtEpal}
										onChange={this.handleChangeCheck}
										disabled={IfmtEpalDisabled}
										color="primary"
										value={"7"}
										name={"RiyouOptionKbn"}
									/>
								}
								label="epalDD連携を利用する"
							/>
						</FormGroup>
					</div>

					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							control={
								<Switch
									checked={OptionKbnStatic}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"1"}
									name={"RiyouOptionKbn"}
								/>
							}
							label="統計情報機能を利用する"
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							className={classes.electronicGroupsHidden}

							control={
								<Switch
									checked={ElectronicReceiptFlg}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									name={"ElectronicReceiptFlg"}
								/>
							}
							label="受領ユーザーとして電子受領を利用する"
						/>
					</FormGroup>
					<div className={classes.electronicGroups}>
						<FormGroup row className={classes.formGroups}>
							<div className={classes.halfTextArea}>
								<Select
									inputLabel={"利用電子書庫"}
									defaultKeyValue={this.setValues("ERReceiverServiceDivide", dataSource)}
									suggestions={ERServiceDivides}
									afterChangeFunction={this.handleChangeERReceiverServiceDivide}
									createTextPrefix={"伝票様式"}
									disabled={ERReceiverServiceDivideDisabled}
									error={this.isError("ERReceiverServiceDivide", errors)}
									isClearable={false}
								/>
								{this.isError("ERReceiverServiceDivide", errors) &&
								<p className={classes.selectHelperText}>
									{errors.ERReceiverServiceDivide}
								</p>
								}
							</div>
						</FormGroup>
						{this.setValues("ERReceiverServiceDivide", dataSource) === "1" &&
						<FormGroup row className={classes.formGroups}>
							<TextField
								label="ペーパーロジック用トークン"
								placeholder="ペーパーロジック用トークン"
								value={this.setValues("ReceiverPaperLogicTokens", dataSource)}
								className={classes.halfTextArea}
								onChange={this.handleChangeText}
								disabled={ERReceiverServiceDivideDisabled}
								name="ReceiverPaperLogicTokens"
								error={this.isError("ReceiverPaperLogicTokens", errors)}
								helperText={this.getErrorText("ReceiverPaperLogicTokens", errors)}
								inputProps={{
									maxLength: 255
								}}
							/>
						</FormGroup>

						}
						{this.setValues("ERReceiverServiceDivide", dataSource) === "2" &&
						<FormGroup row className={classes.formGroups}>
							<TextField
								label="受領時アップロード先エリアCD"
								placeholder="未入力の場合は、事業者コードがアップロード先エリアCDとなります"
								value={this.setValues("SecomReceiverAreaCD", dataSource)}
								className={classes.halfTextArea}
								onChange={this.handleChangeText}
								disabled={ERReceiverServiceDivideDisabled}
								name="SecomReceiverAreaCD"
								error={this.isError("SecomReceiverAreaCD", errors)}
								helperText={this.getErrorText("SecomReceiverAreaCD", errors)}
								inputProps={{
									maxLength: 13
								}}
							/>
						</FormGroup>
						}
						<FormGroup row className={classes.formGroups}>
							<FormControlLabel
								control={
									<Switch
										checked={OptionKbnElectronicEpal}
										onChange={this.handleChangeCheck}
										disabled={ERReceiverServiceDivideDisabled}
										color="primary"
										value={"8"}
										name={"RiyouOptionKbn"}
									/>
								}
								label="epalDD連携を利用する"
							/>
						</FormGroup>
						<FormGroup row className={classes.formGroups}>
							<FormControlLabel
								control={
									<Switch
										checked={OptionKbnDeliveryMobileReceipt}
										onChange={this.handleChangeCheck}
										disabled={ERReceiverServiceDivideDisabled}
										color="primary"
										value={"11"}
										name={"RiyouOptionKbn"}
									/>
								}
								label="配送モバイルでも受領する"
							/>
						</FormGroup>
						<FormGroup row className={classes.formGroups}>
							<FormControlLabel
								control={
									<Switch
										checked={OptionKbnReceiptArrivalPdf}
										onChange={this.handleChangeCheck}
										disabled={ERReceiverServiceDivideDisabled}
										color="primary"
										value={"12"}
										name={"RiyouOptionKbn"}
									/>
								}
								label="帳票出力機能を利用する"
							/>
						</FormGroup>
					</div>
					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							className={classes.electronicGroupsHidden}

							control={
								<Switch
									checked={MakerElectronicReceiptFlg}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									name={"MakerElectronicReceiptFlg"}
								/>
							}
							label="メーカーとして電子受領を利用する"
						/>
					</FormGroup>
					<div className={classNames(classes.electronicGroups, classes.makerElectronicGroups)}>
						<FormGroup row className={classes.formGroups}>
							<div className={classes.halfTextArea}>
								<Select
									inputLabel={"利用電子書庫"}
									defaultKeyValue={this.setValues("ERMakerServiceDivide", dataSource)}
									suggestions={ERServiceDivides}
									afterChangeFunction={this.handleChangeERMakerServiceDivide}
									disabled={ERMakerServiceDivideDisabled}
									error={this.isError("ERMakerServiceDivide", errors)}
									isClearable={false}
								/>
								{this.isError("ERMakerServiceDivide", errors) &&
								<p className={classes.selectHelperText}>
									{errors.ERMakerServiceDivide}
								</p>
								}
							</div>
						</FormGroup>
						{this.setValues("ERMakerServiceDivide", dataSource) === "1" &&
						<FormGroup row className={classes.formGroups}>
							<TextField
								label="ペーパーロジック用トークン"
								placeholder="ペーパーロジック用トークン"
								value={this.setValues("MakerPaperLogicTokens", dataSource)}
								className={classes.halfTextArea}
								onChange={this.handleChangeText}
								//disabled={ERReceiverServiceDivideDisabled}
								name="MakerPaperLogicTokens"
								error={this.isError("MakerPaperLogicTokens", errors)}
								helperText={this.getErrorText("MakerPaperLogicTokens", errors)}
								inputProps={{
									maxLength: 255
								}}
							/>
						</FormGroup>
						}
						{this.setValues("ERMakerServiceDivide", dataSource) !== "0" &&
						<FormGroup row className={classes.formGroups}>
							<div className={classes.halfTextArea}>
								<Select
									inputLabel={"連携ファイル種類"}
									defaultKeyValue={this.setValues("ERMakerSendSlipsDivide", dataSource)}
									suggestions={ERMakerSendSlipsDivide}
									afterChangeFunction={this.handleChangeERMakerSendSlipsDivide}
									disabled={ERMakerSendSlipsDivideDisabled}
									error={this.isError("ERMakerSendSlipsDivide", errors)}
									isClearable={false}
								/>
							</div>
						</FormGroup>
						}
					</div>

					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							className={classes.electronicGroupsHidden}

							control={
								<Switch
									checked={OptionKbnEntry}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"6"}
									name={"OptionKbnEntry"}
								/>
							}
							label="エントリー機能を利用する　※エントリー時の必須項目を設定"
						/>
					</FormGroup>
					<div className={classes.entryGroups}>
						<FormGroup row className={classes.formGroups}>
							<div className={classes.halfTextArea}>
								<Select
									inputLabel={"データ提供元"}
									defaultKeyValue={this.setValues("DataTeikyoumotoCD", dataSource)}
									suggestions={settings.keiyakukigyouData}
									afterChangeFunction={this.handleChangeDataTeikyoumotoCD}
									createTextPrefix={"データ提供元"}
									disabled={EntryFlgDivideDisabled}
									error={this.isError("DataTeikyoumotoCD", errors)}
								/>
								{this.isError("DataTeikyoumotoCD", errors) &&
								<p className={classes.selectHelperText}>
									{errors.DataTeikyoumotoCD}
								</p>
								}
							</div>
							<div className={classes.halfDivider}/>
							<div className={classes.halfTextArea}>
								<Select
									inputLabel={"物流母店"}
									defaultKeyValue={this.setValues("ButsuryuBotenCD", dataSource)}
									suggestions={butsuryuBotenList}
									afterChangeFunction={this.handleChangeButsuryuBotenCD}
									createTextPrefix={"物流母店"}
									disabled={EntryFlgDivideDisabled}
									error={this.isError("ButsuryuBotenCD", errors)}
								/>
								{this.isError("ButsuryuBotenCD", errors) &&
								<p className={classes.selectHelperText}>
									{errors.ButsuryuBotenCD}
								</p>
								}
							</div>
							<div className={classes.halfDivider}/>
							<div className={classes.halfTextArea}>
								<Select
									inputLabel={"メーカー"}
									defaultKeyValue={this.setValues("MakerCD", dataSource)}
									suggestions={makerList}
									afterChangeFunction={this.handleChangeMakerCD}
									createTextPrefix={"メーカー"}
									disabled={EntryFlgDivideDisabled}
									error={this.isError("MakerCD", errors)}
								/>
								{this.isError("MakerCD", errors) &&
								<p className={classes.selectHelperText}>
									{errors.MakerCD}
								</p>
								}
							</div>
						</FormGroup>
					</div>

					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							className={classes.electronicGroupsHidden}

							control={
								<Switch
									checked={OptionKbnASN}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"9"}
									name={"OptionKbnASN"}
								/>
							}
							label="ASN連携を利用する"
						/>
					</FormGroup>
					<div className={classes.entryGroups}>
						<FormGroup row className={classes.formGroups}>
							<div className={classes.halfTextArea}>
								<Select
									inputLabel={"ASN連携先企業"}
									defaultKeyValue={this.setValues("ASNRenkeiCD", dataSource)}
									suggestions={settings.asnRenkeiData}
									afterChangeFunction={this.handleChangeASNRenkeiCD}
									createTextPrefix={"ASN連携先企業"}
									disabled={ASNRenkeiDivideDisabled}
									error={this.isError("ASNRenkeiCD", errors)}
								/>
								{this.isError("ASNRenkeiCD", errors) &&
								<p className={classes.selectHelperText}>
									{errors.ASNRenkeiCD}
								</p>
								}
							</div>
							<div className={classes.halfDivider}/>
							<div className={classes.halfTextArea}/>
							<div className={classes.halfDivider}/>
							<div className={classes.halfTextArea}/>
						</FormGroup>
					</div>

					<FormGroup row className={classes.formGroups}>
						<FormControlLabel
							control={
								<Switch
									checked={OptionKbnDeliveryStatus}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"10"}
									name={"RiyouOptionKbn"}
								/>
							}
							label="納品状況照会を利用する"
						/>
					</FormGroup>
				</TabContainer>
				}
			</div>
		);
	}
}

innerForm.propTypes = {
	dataSource: PropTypes.object,
	allDisabled: PropTypes.bool,
	afterChangeFunc: PropTypes.func,
	isAddConditions: PropTypes.bool,
	isClear: PropTypes.bool
};
innerForm.defaultProps = {
	dataSource: {},
	allDisabled: true,
	isAddConditions: false,
	isClear: false
}

function mapStateToProps(state) {
	return {
		navigation: state.navigation,
		auth: state.auth,
		settings: state.masterJigyoushaSettings,
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(innerForm);



// WEBPACK FOOTER //
// ./src/routes/master/jigyousha/components/inner-form.js